import React, { Component } from 'react';

const initData = {
    iconClass: "far fa-lightbulb text-primary mr-1",
    preHeading: "Kullanıcı Dostu Tasarım",
    heading: "Modern Arayüz",
    headingText: "Socia'nın modern ve şık arayüzü ile etkinlikleri keşfetmek artık çok kolay!  Etkinliklere anında eriş, kaybolmadan keşfet.",
    headingTexttwo: " "
}

const data = [
    {
        image: "/img/Home.png"
    },
    {
        image: "/img/all_events.png"
    },
    {
        image: "/img/profile.png"
    },
    {
        image: "/img/profile_saved_events.png"
    },
    {
        image: "/img/notifications.png"
    },
    {
        image: "/img/events_details.png"
    },
    {
        image: "/img/filter.png"
    }
]

class ScreenshotSection extends Component {
    state = {
        initData: {},
        data: []
    }
    componentDidMount(){
        this.setState({
            initData: initData,
            data: data
        })
    }
    render() {
        return (
            <section 
                id="screenshots" 
                className="section screenshots-area ptb_100" 
                style={{ 
                    background: 'radial-gradient(circle, #2F2D51 0%, #1A1E28 100%)',
                    color: 'white'
                }}
            >
                <div className="container">
                    <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-8">
                        {/* Section Heading */}
                        <div className="section-heading text-center">
                        <span className="d-inline-block rounded-pill shadow-sm fw-5 px-4 py-2 mb-3">
                            <i className={this.state.initData.iconClass} />
                            <span className="text-primary">{this.state.initData.preHeading}</span> {this.state.initData.preHeadingspan}
                        </span>
                        <h2 className="text-capitalize" style={{ color: 'white' }}>{this.state.initData.heading}</h2>
                        <p className="d-none d-sm-block mt-4" style={{ fontSize: '20px', color: 'white' }}>{this.state.initData.headingText}</p>
                        <p className="d-block d-sm-none mt-4" style={{ color: 'white' }}>{this.state.initData.headingTexttwo}</p>
                        </div>
                    </div>
                    </div>
                    <div className="row">
                    <div className="col-12">
                        {/* App Screenshot Slider Area */}
                        <div className="app-screenshots">
                            {/* Single Screenshot Item */}
                            {data.map((item, idx) => {
                                return(
                                    <div key={`so_${idx}`} className="single-screenshot">
                                        <img src={item.image} alt="" />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default ScreenshotSection;